module.exports = __webpack_public_path__ + "img/LR-LIFETAKT_kachel-cell-essence.752315eb.png";